<template>
    <div class="payment-success p-3 bg-white" :style="{ paddingBottom: '200px' }">
        <div class="" :style="{ paddingBottom: '200px' }">
            <!--
            <div @click="handleSupport"
                class="d-flex justify-content-end align-items-center gap-1 position-relative z-3">
                <p class="mb-0 font-size-12">{{ $t('esim_help') }}</p>
                <van-icon name="question" size="18" />
            </div>
            -->
            <div class="d-flex flex-column justify-content-center align-items-center position-relative z-2">
                <div class="mb-4 cs-icon-success mt-4">
                    <van-icon name="checked" color="#C41627" size="71" class="position-relative z-2" />
                    <div class="bg-icon"></div>
                </div>
                <h5 class="mb-3 fw-bold font-size-20">{{ $t('successfully') }}</h5>
                <p class="text-center px-5">{{ $t('esim_qr_code_instruction', { isdn: isdn }) }}</p>
            </div>
            <div class="mb-3 d-flex flex-column justify-content-center align-items-center">
                <p class="font-size-14">{{ $t('esim_serial_number') }}: {{ serial }}</p>
                <div class="d-flex justify-content-center mb-3">
                    <div class="image-base64" v-if="qrImageSrc">
                        <!-- <van-image width="250" height="200" :src="qrContent" /> -->
                        <van-image width="200" height="200" :src="qrImageSrc" />
                    </div>
                    <div class="image-base64" v-else>
                        <!-- <van-image width="250" height="200" :src="qrContent" /> -->
                        <img width="250" src="@/static/eSim/test-qr.svg" />
                    </div>
                </div>
                <!--Hoai 
                <div class="d-flex justify-content-center gap-3">
                    <div @click="downloadQRCode">
                        <img width="32" height="32" src="@/static/arrow-down-solid.svg" />
                    </div>
                    <div @click="shareQRCode">
                        <img width="32" height="32" src="@/static/share-nodes-solid.svg" />
                    </div>
                </div>
                -->
            </div>
        </div>
        <div class="fixed-bottom bg-white">
            <div class="p-4">
                <!--
                <div class="d-flex justify-content-start align-items-center gap-2">
                    <van-icon name="info" size="18px" :style="{ color: '#4A4A4A99' }" />
                    <p class="mb-0 font-size-12">{{ $t('esim_activated_notice', { simExpireDate: simExpireDate }) }}</p>
                </div>
                -->
                <van-button @click="goHome" class="btn btn-primary w-100 mt-3 text-uppercase">{{ $t('esim_ok') }}</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Image } from "vant";
// import { base64Images } from "@/pages/EOrder/base64.js";
import { CONSTANTS } from "@/helpers/constants";
import store from "@/store";
import { mapState } from "vuex";

export default {
    components: {
        [Image.name]: Image
    },
    inject: ["$bridge"],
    data() {
        return {
            isdn: "",
            qrCode: "",
            serial: "",
            simExpireDate: "",
        };
    },
    computed: {
        ...mapState("headerStore", ["title"]),
        qrImageSrc() {
            const prefix = 'data:image/png;base64,';
            return this.qrCode?.startsWith(prefix)
                ? this.qrCode
                : prefix + this.qrCode;
        }
    },

    created() {
        this.isdn = this.$route.query.isdn || "";
        this.qrCode = this.$route.query.qrCode || "";
        this.serial = this.$route.query.serial || "";
        this.simExpireDate = this.$route.query.simExpireDate || "";
    },
    mounted() {
        this.changeTitle(this.$t(this.title));
    },
    watch: {
        $route: {
            handler: function (value) {
                this.$store.dispatch("headerStore/setTitle", "esim_payment");
            },
            immediate: true,
        },
    },
    methods: {
        changeTitle(title) { 
            const contentData = {
                title: title,
                bgColor: this.color_primary(),
                color: "#ffffff",
            };
            this.$bridge.callHandler("setBarTitle", contentData).then((data) => { });
        },
        color_primary() {
            return CONSTANTS.color_primary;
        },
        handleSupport() {
            this.$router.push('/support');
        },
        downloadQRCode() {
            const pureBase64 = this.qrCode.replace(/^data:image\/\w+;base64,/, "");
            console.log("downloadQRCode: ", {
                type: "base64",
                fileName: "qr-code.png",
                content: pureBase64, 
                trxId: this.serial ,
            });
            this.$bridge.callHandler("download", {
                content: pureBase64,
                type: "base64",
                fileName: "qr-code.png",
                trxId: this.serial ,
            });
        },
        shareQRCode() {
            const pureBase64 = this.qrCode.replace(/^data:image\/\w+;base64,/, "");
            console.log("shareQRCode: ", {
                fileName: "qr-code.png",
                content: pureBase64,
                type: "image/png",
                message: "",
                trxId: this.serial ,
            });
            this.$bridge.callHandler("share", {
                trxId: this.serial ,
                message: "",
                fileName: "qr-code.png",
                content: pureBase64,
                type: "image/png"                
            })
        },
        goHome() {
            this.$router.replace({ path: "/" });
            setTimeout(() => {
                this.$router.push({ path: "/home", query: { tab: "buyMetfoneEsim" } });
            }, 0);
        }
    },
}
</script>
<style>
.payment-success {
    width: 100%;
    min-height: 100vh;
}

.cs-icon-success {
    position: relative;
    z-index: 0;
}

.payment-success::before {
    content: "";
    display: block;
    position: absolute;
    top: 0%;
    left: 50%;
    width: 100%;
    height: 200px;
    /* background: #D2E1F7; */
    border-radius: 50%;
    filter: blur(40px);
    transform: translate(-50%, -50%);
    z-index: 0;
}
</style>
